export const VISIBLE_TYPE = 'visible'
export const SELECT_TYPE = 'select'
export const COLLAPSE_SIDEBAR_TYPE = 'collapse_sidebar'
export const EDIT_MODE_CHANGE_TYPE = 'edit_mode_change'
export const LOADING_TYPE = 'loading'
export const POPUP_CONTENT_CHANGE_TYPE = 'popup_content'
export const SEARCH_CHANGED_TYPE = 'search_changed'
export const SEARCH_RESULT = 'search_resulted'
export const FILTER_RESULT = 'filter_resulted'
export const SHOWING_FILTERS = 'showing_filters'
export const WAIT_FOR_SERVER = 'waiting_for_server'
export const DELETE_FEATURE = 'delete_feature'
export const OPEN_TOUR = 'open_tour'
export const OPEN_PANEL = 'open_panel'
export const HIDE_POPUP = 'hide_popup'
export const SAVE_FEATURE_GEOM = 'save_feature_geom'
export const ADD_MODE_CHANGE = 'add_mode_change'
export const SET_AUTH = 'SET_AUTH'
export const SHOULD_BE_SHOWN = 'should_be_shown'
export const ACCESSIBILITY = 'ACCESSIBILITY'

export const visiblePlacesAction = function (places) {
  return {
    type: VISIBLE_TYPE,
    places: places
  }
}

export const selectAction = function (placeId) {
  return {
    type: SELECT_TYPE,
    placeId: placeId
  }
}

export const collapseSidebarAction = function (collapsed) {
	return {
		type: COLLAPSE_SIDEBAR_TYPE,
		collapsed: collapsed
	}
}

export const editModeChangeAction = function (editMode) {
  return {
    type: EDIT_MODE_CHANGE_TYPE,
    editMode: editMode
  }
}

export const loadingAction = function (loading) {
  return {
    type: LOADING_TYPE,
    loading: loading
  }
}

export const searchChangedAction = function (query) {
  return {
    type: SEARCH_CHANGED_TYPE,
    query: query
  }
}

export const searchResultsArrived = function (results) {
  return {
    type: SEARCH_RESULT,
    searchResults: results
  }
}

export const filterChangedAction = function (results) {
  return {
    type: FILTER_RESULT,
    filteredResults: results
  }
}

export const changeShowFiltersAction = function (show) {
  return {
    type: SHOWING_FILTERS,
    show: show
  }
}

export const waitForServerAction = function (status) {
  return {
    type: WAIT_FOR_SERVER,
    status: status
  }
}

export const deleteFeatureAction = function (id) {
  return {
    type: DELETE_FEATURE,
    id: id
  }
}

export const openTourAction = function (isOpened) {
  return {
    type: OPEN_TOUR,
    isTourOpened: isOpened
  }
}

export const openPanelAction = function (open) {
  return {
    type: OPEN_PANEL,
    isPanelOpened: open
  }
}

export const hidePopupAction = function (hide) {
  return {
    type: HIDE_POPUP,
    hidePopup: hide,
  }
}

export const saveFeatureGeomAction = function (id, place_or_cluster) {
  return {
    type: SAVE_FEATURE_GEOM,
    saveFeatureGeomId: id,
    savePlaceOrCluster: place_or_cluster,
  }
}

export const addModeChangeAction = function (mode) {
  return {
    type: ADD_MODE_CHANGE,
    addingFeature: mode
  }
}

export const setAuthorizedUserAction = function (user) {
  return {
    type: SET_AUTH,
    authorizedUser: user
  }
}

export const shouldBeShownAction = function (ids) {
  return {
    type: SHOULD_BE_SHOWN,
    ids: ids
  }
}

export const setAccessibilityVersionAction = function (status) {
  return {
    type: ACCESSIBILITY,
    status: status
  }
}


// WEBPACK FOOTER //
// ./src/actions.js